(() => {
  'use strict';

  const sectionSelector = '[data-section-type]';

  if (customElements.get('recently-viewed')) return;

  customElements.define(
    'recently-viewed',
    class extends HTMLElement {
      constructor() {
        super();
        this.section = this.closest(sectionSelector);
        this.howManyToShow = parseInt(this.dataset.limit, 10) || 3;
        this.target = this.dataset.target;
        this.wrapperId = this.dataset.wrapperId || this.id;
        this.enableSwiper = this.dataset.enableSwiper === 'true';
        this.exclude = this.dataset.exclude || null;
        this.swiper = null;
      }

      connectedCallback() {
        // Fetch one extra so we still fill the grid after removing the current product
        const fetchCount = this.exclude ? this.howManyToShow + 1 : this.howManyToShow;

        Shopify.Products.showRecentlyViewed({
          howManyToShow: fetchCount,
          wrapperId: this.wrapperId,
          section: this.section,
          target: this.target,
          onComplete: () => {
            const wrapper = document.querySelector(`#${this.wrapperId}`);
            if (wrapper) {
              // Remove the card for the currently open product
              if (this.exclude) {
                const links = wrapper.querySelectorAll('[data-product-link]');
                links.forEach((link) => {
                  const href = link.getAttribute('data-product-link') || link.getAttribute('href') || '';
                  if (href.includes(`/products/${this.exclude}`)) {
                    const card = link.closest('[data-grid-item]') || link.parentElement;
                    if (card) card.remove();
                  }
                });
              }

              // Remove out-of-stock cards, and any card that didn't resolve to an
              // available product (blank/gated/locked responses render with an empty
              // data-product-available and would otherwise show only a "Sold Out" label).
              wrapper
                .querySelectorAll('[data-grid-item]:not([data-product-available="true"])')
                .forEach((card) => card.remove());

              // Trim any extra cards beyond the original limit
              const remaining = wrapper.querySelectorAll('[data-grid-item]');
              for (let i = this.howManyToShow; i < remaining.length; i++) {
                remaining[i].remove();
              }
            }

            if (this.enableSwiper) {
              this.initSwiper();
            }

            this.dispatchEvent(
              new CustomEvent('theme:recently-viewed:loaded', { bubbles: false })
            );
          },
        });
      }

      initSwiper() {
        if (typeof Swiper === 'undefined') return;

        const existingContainer = this.querySelector('[data-recently-viewed-swiper]');

        if (existingContainer) {
          this.mountSwiper(existingContainer);
          return;
        }

        const cards = Array.from(this.children).filter((child) => child.nodeType === Node.ELEMENT_NODE);

        if (cards.length <= 1) return;

        const swiperContainer = document.createElement('div');
        swiperContainer.className = 'recently-viewed-swiper swiper';
        swiperContainer.setAttribute('data-recently-viewed-swiper', '');

        const swiperWrapper = document.createElement('div');
        swiperWrapper.className = 'swiper-wrapper';

        cards.forEach((card) => {
          card.classList.add('swiper-slide');
          swiperWrapper.appendChild(card);
        });

        swiperContainer.append(swiperWrapper);
        this.appendChild(swiperContainer);

        this.mountSwiper(swiperContainer);
      }

      mountSwiper(swiperContainer) {
        if (this.swiper && typeof this.swiper.destroy === 'function') {
          this.swiper.destroy(true, true);
        }

        this.swiper = new Swiper(swiperContainer, {
          slidesPerView: 'auto',
          spaceBetween: 10,
          autoHeight: true,
          observer: true,
          observeParents: true,
        });
      }
    }
  );
})();
